import { render } from "./NewList.vue?vue&type=template&id=4726c5c8&scoped=true"
import script from "./NewList.vue?vue&type=script&lang=js"
export * from "./NewList.vue?vue&type=script&lang=js"

import "./NewList.vue?vue&type=style&index=0&id=4726c5c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4726c5c8"]])

export default __exports__